import React from 'react';
import { Search } from 'lucide-react';
import { useSearch } from '../contexts/SearchContext';
import { useClickOutside } from '../hooks/useClickOutside';
import SectionNavLinks from './SectionNavLinks';

const Navigation: React.FC = () => {
  const { searchTerm, setSearchTerm, clearSearchWithAnimation } = useSearch();

  const searchRef = useClickOutside((event) => {
    if (event) {
      const target = event.target as Element;
      if (target.closest('.search-results')) {
        return;
      }
    }

    if (searchTerm.trim()) {
      clearSearchWithAnimation();
    }
  });

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  return (
    <nav className="navigation" aria-label="Search and sections">
      <div className="nav-top">
        <SectionNavLinks className="nav-links nav-links--header" />
        <div className="nav-search" ref={searchRef}>
          <input
            type="text"
            placeholder="Search site..."
            value={searchTerm}
            onChange={handleSearch}
            className="nav-search-input"
          />
          <Search size={18} className="nav-search-icon" />
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
